import React, { useState, useContext } from "react";
import "../styles/Dashboard.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import BonafideTemplate from "../components/BonafideTemplate";
import { StudentDetailsContext } from "../store/student-details";
import { Modal } from "@mui/material";
import "../components/bonafide.css";
import DescriptionIcon from "@mui/icons-material/Description";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import GroupsIcon from '@mui/icons-material/Groups';
const Bonafide = () => {
  const [inputAdmissionNumber, setInputAdmissionNumber] = useState(0);
  const [fromYear, setFromYear] = useState(0);
  const [toYear, setToYear] = useState(0);
  const [leavingYear, setLeavingYear] = useState(0);
  const [isSearchBtnClicked, setIsSearchBtnClicked] = useState(false);
  const StudentContext = useContext(StudentDetailsContext);
  const [showModal, handleShowModal] = useState(false);
  function showDetailsHandler() {
    setIsSearchBtnClicked(true);
    StudentContext.getStudentDetailsByAdmission(inputAdmissionNumber);
  }
  function GenerateBonafideHandler() {
    handleShowModal(true);
  }
  return (
    <div className="dashboardMainDiv">
       <div className="dashboardMenu">
        <ul className="dashboardDropdownList">
          <div className="listItemContainer activeContainer">
            <li className="listItem">
              <Link className="linkItem" to="/">
                Dashboard
              </Link>
            </li>
            <li className="listItemIcon">
              <DashboardIcon />
            </li>
          </div>

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/students">
                Students
              </Link>
            </li>
            <li className="listItemIcon">
              <SchoolIcon />
            </li>
          </div> */}

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/analytics">
                Analytics
              </Link>
            </li>
            <li className="listItemIcon">
              <BarChartIcon />
            </li>
          </div> */}

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/bonafide">
                Bonafide
              </Link>
            </li>
            <li className="listItemIcon">
              <ArticleIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/receipt">
                Receipt
              </Link>
            </li>
            <li className="listItemIcon">
              <ReceiptLongIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/exams">
                Exams
              </Link>
            </li>
            <li className="listItemIcon">
              <DescriptionIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/feeDetails">
                Fee Details
              </Link>
            </li>
            <li className="listItemIcon">
              <CurrencyRupeeIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/uploadAttendance">
                Attendance
              </Link>
            </li>
            <li className="listItemIcon">
              <GroupsIcon />
            </li>
          </div>
        </ul>
      </div>
      <div className="dashboardContent">
        <div className="dashboardContentContainer">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <p>Enter student admission number to download bonafide.</p>
            <div className="form-group col-lg-7 my-5">
              <input
                type="Number"
                placeholder="Enter student admission number"
                className="form-control my-2"
                onChange={(e) => setInputAdmissionNumber(e.target.value)}
              />

              <input
                type="Number"
                placeholder="Studied in class from"
                className="form-control my-2"
                onChange={(e) => setFromYear(e.target.value)}
              />

              <input
                type="Number"
                placeholder="To"
                className="form-control my-2"
                onChange={(e) => setToYear(e.target.value)}
              />

              <input
                type="Number"
                placeholder="select the school leaving year"
                className="form-control my-2"
                onChange={(e) => setLeavingYear(e.target.value)}
              />
              <button
                className="btn btn-sm btn-success px-5 mt-5"
                onClick={showDetailsHandler}
              >
                Show Details
              </button>
            </div>

            {isSearchBtnClicked ? (
              <>
                {StudentContext.personalDetails &&
                StudentContext.personalDetails.Name ? (
                  <>
                    <p className="text text-start">
                      Check the student details..
                    </p>
                    <div className="card col-lg-4 p-2">
                      <p>Name : {StudentContext.personalDetails.Name}</p>
                      <p>
                        Father Name :{" "}
                        {StudentContext.personalDetails.FatherName}
                      </p>
                      <p>
                        Mother Name :{" "}
                        {StudentContext.personalDetails.MotherName}
                      </p>
                      <p>
                        Admission Number :{" "}
                        {StudentContext.personalDetails.AdmissionNumber}
                      </p>
                      <p>
                        PresentClass :{" "}
                        {StudentContext.personalDetails.className}
                      </p>
                      <p>From : {fromYear}</p>
                      <p>To : {toYear}</p>
                      <button
                        className="btn btn-sm btn-primary my-2"
                        onClick={GenerateBonafideHandler}
                      >
                        <Link
                          to={`/generateBonafide/from/${fromYear}/to/${toYear}/leavingYear/${leavingYear}`}
                          style={{ color: "white" }}
                        >
                          Generate Bonafide &nbsp; <ReceiptLongIcon />
                        </Link>
                      </button>
                    </div>
                  </>
                ) : (
                  <div>
                    <p>No student found with this admission number.</p>
                  </div>
                )}
              </>
            ) : (
              <></>
            )}
          </div>
          {
            <Modal open={showModal}>
              <div className="BonafideModal card">
                <div className="BonafideModalContent">
                  <BonafideTemplate
                    studentName={StudentContext.personalDetails.Name}
                    className={StudentContext.personalDetails.className}
                    fatherName={StudentContext.personalDetails.FatherName}
                    currDate={new Date().toLocaleDateString()}
                    admissionId={StudentContext.personalDetails.AdmissionNumber}
                  />
                </div>
              </div>
            </Modal>
          }
        </div>
      </div>
    </div>
  );
};

export default Bonafide;
